import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import {
  Link,
  Route,
  Routes,
  useParams,
} from 'react-router-dom';
import DataTable from '../../common/components/DataTable';
import UserIcon from '../../common/components/UserIcon';
import LargeUserPill from '../../common/components/LargeUserPill';
import SquadResource from '../../common/resource/SquadResource';
import Placeholder from '../../common/components/Placeholder.tsx';
import BasicPage from '../../common/layout/BasicPage';

function SquadIndex() {
  return (
    <BasicPage title="Squads">
      <DataTable
        url="/resource/squads?with[]=users"
        renderRow={(squad) => (
          <tr>
            <th>
              <Link to={`/squads/${squad.id}`}>
                {squad.name}
              </Link>
            </th>

            <td>
              {squad.users.map((user) => (
                <UserIcon
                  className="mr-1"
                  size="50px"
                  user={user}
                  key={user.id}
                  round
                />
              ))}
            </td>
          </tr>
        )}
      />
    </BasicPage>
  );
}

function Squad() {
  const { id } = useParams();
  const [squad, setSquad] = useState({});
  const [loading, setLoading] = useState(false);

  async function load() {
    setLoading(true);
    setSquad(await SquadResource.get(id));
    setLoading(false);
  }

  useEffect(() => { load(); }, [id]);

  const roles = {};

  function setRole(user) {
    if ([28, 29, 30, 39, 46, 47].includes(user.job.id)) {
      return user;
    }

    if (user.job.parent_job_id === 56) {
      roles.ba = user;
      return null;
    }

    if (user.job.parent_job_id === 57) {
      roles.dm = user;
      return null;
    }

    if (user.job.parent_job_id === 60) {
      roles.qe = user;
      return null;
    }

    if (user.job.id === 42 || user.job.id === 17) {
      roles.el = user;
      return null;
    }

    return user;
  }

  let users = [];

  if (squad.users) {
    users = squad.users.map(setRole).filter((user) => user !== null);
  }

  return (
    <BasicPage title={squad.name}>
      <Row>
        {Object.values(roles).length !== 0 && (
          <Col md={4}>
            <Leader user={roles.el} />
            <Leader user={roles.dm} />
            <Leader user={roles.ba} />
            <Leader user={roles.qe} />
          </Col>
        )}

        <Col>
          <Card>
            <Card.Header>Members</Card.Header>

            <table className="table mb-0">
              <tbody>
                {loading && (
                  <>
                    <tr>
                      <td>
                        <Placeholder.Circle size={48} className="mr-1" />
                        <Placeholder.Rectangle width={200} height={50} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Placeholder.Circle size={48} className="mr-1" />
                        <Placeholder.Rectangle width={200} height={50} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Placeholder.Circle size={48} className="mr-1" />
                        <Placeholder.Rectangle width={200} height={50} />
                      </td>
                    </tr>
                  </>
                )}
                {users.map((user) => (
                  <tr key={user.id}>
                    <td><LargeUserPill user={user} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Col>
      </Row>
    </BasicPage>
  );
}

function Leader({ user }) {
  if (user === null || typeof user === 'undefined') {
    return null;
  }

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row>
          <Col md={3}>
            <UserIcon user={user} size="75px" round />
          </Col>

          <Col>
            <h3>{user.name}</h3>
            <div className="mt-2 text-muted" style={{ fontSize: '1.2em' }}>
              {user.job.title}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default function () {
  return (
    <Routes>
      <Route path="/:id" element={<Squad />} />
      <Route path="" element={<SquadIndex />} />
    </Routes>
  );
}
